/**
 * Страны, которые уводят на другой сайт марки.
 *
 * Случаев два, и устроены они по-разному.
 *
 *   Россия — страны нет среди рынков магазина. Пункт добавляется
 *   скриптом. Всё, что ниже про Россию, — об этом случае.
 *
 *   Казахстан — продаёт его другой сайт. Пока рынок KZ в магазине
 *   есть, пункт Shopify остаётся на своём месте и превращается в ссылку
 *   (см. redirectNative); когда рынок выключен, пункт добавляется, как
 *   у России. Посетителя, которого Shopify определил в Казахстане,
 *   уводим на wau.kz сами — см. «Переброс» ниже.
 *
 * Задача. В списке стран нужен пункт «Россия», ведущий на wau.ru —
 * российский магазин той же марки. Обычным способом это не делается:
 * список формирует Shopify из стран, включённых в рынки магазина.
 * России там нет и быть не должно — иначе покупатель начал бы
 * оформлять заказ здесь, с доставкой, которой нет.
 *
 * Поэтому пункт добавляется скриптом и работает как ссылка, а не как
 * переключатель рынка: форму локализации он не трогает.
 *
 * Где появляется: во всех переключателях страны на странице — в шапке
 * (от 751 px), в выезжающем меню и в подвале. Тема выводит их одним
 * сниппетом, поэтому обходим все формы разом.
 *
 * Список стран тема подгружает лениво, из <template> и только когда
 * переключатель попал в область просмотра. Поэтому ждём появления
 * пунктов наблюдателем, а не вставляем один раз при загрузке.
 *
 * Название страны берём у браузера через Intl: на 21 языке витрины оно
 * своё, а держать свою таблицу переводов значит ловить расхождения.
 * Если Intl недоступен, остаётся английское Russia — пункт всё равно
 * найдётся.
 *
 * Вторая часть файла — предложение перейти, которое показывается
 * посетителю из России само, не дожидаясь, пока он полезет в список
 * стран. Обе части живут вместе намеренно: адрес магазина один, и
 * разнеси их по файлам — рано или поздно они разойдутся.
 */
(function () {
  'use strict';

  // Код страны, подпись валюты, куда уводить и текст предложения.
  //
  // Текст по-русски и только по-русски: предложение видит тот, кого
  // Shopify определил в России. Утверждаем лишь то, что проверено
  // на самом wau.ru — цены в рублях. Про доставку и способы оплаты
  // здесь не пишем: это надо сверять с российским магазином, а неверное
  // обещание в таком месте дороже отсутствующего.
  var TARGETS = [
    {
      code: 'RU',
      currency: 'RUB',
      symbol: '₽',
      url: 'https://wau.ru/',
      hreflang: 'ru',
      offer: {
        title: 'Вы заходите из России',
        text: 'У марки есть российский магазин wau.ru — цены в рублях.',
        go: 'Перейти на wau.ru',
        stay: 'Остаться здесь',
        close: 'Закрыть',
      },
    },
    // Без offer, зато redirect: казахстанца не спрашиваем, а уводим
    // (решение владельца 03.11.2026). Рынок и склад KZ из Shopify убраны,
    // доставки в Казахстан отсюда нет — купить здесь он всё равно не
    // сможет, а wau.kz продаёт в тенге с местной доставкой.
    {
      code: 'KZ',
      currency: 'KZT',
      symbol: '₸',
      url: 'https://wau.kz/',
      // wau.kz открывается по-русски, казахский там отдельным разделом.
      hreflang: 'ru',
      redirect: true,
    },
  ];

  var MARK = 'data-external-store';
  var FLAGS = '//cdn.shopify.com/static/images/flags/';

  function pageLanguage() {
    return document.documentElement.lang || 'en';
  }

  /** Название страны на языке витрины. */
  function countryName(code) {
    try {
      var names = new Intl.DisplayNames([pageLanguage()], { type: 'region' });
      return names.of(code) || code;
    } catch (e) {
      return code;
    }
  }

  function buildItem(target, name) {
    var li = document.createElement('li');
    li.className = 'disclosure-list__item';
    li.setAttribute(MARK, target.code);

    var a = document.createElement('a');
    // Намеренно без data-disclosure-option: этот атрибут тема использует,
    // чтобы навесить отправку формы локализации. Нам нужен обычный переход.
    a.className = 'disclosure-list__option';
    a.href = target.url;
    a.hreflang = target.hreflang;
    a.lang = 'ru';
    a.rel = 'noopener';

    // Флаг тема берёт не из спрайта, а из переменной --background-image
    // с картинкой Shopify: у соседних пунктов это inline-стиль вида
    // url(//cdn.shopify.com/static/images/flags/ca.svg?width=20). Без него
    // остаётся пустой квадрат 20x20 — проверено на витрине.
    var flag = document.createElement('span');
    flag.className = 'f-country-flags f-country-flags--' + target.code;
    flag.style.setProperty('--background-image', 'url(' + FLAGS + target.code.toLowerCase() + '.svg?width=20)');
    a.appendChild(flag);
    a.appendChild(document.createTextNode(name));

    var cur = document.createElement('span');
    cur.className = 'localization-form__currency';
    cur.textContent = '(' + target.currency + ' ' + target.symbol + ')';
    a.appendChild(cur);

    li.appendChild(a);
    return li;
  }

  /*
   * Пункт ставится первым, а не по алфавиту.
   *
   * Сначала он вставлялся по алфавиту — сравнением видимых названий
   * сравнителем языка страницы. На английской витрине вышло верно,
   * между Romania и Rwanda, а на русской «Россия» оказалась между
   * «Буркина-Фасо» и «Чехия».
   *
   * Причина: порядок задаёт Shopify, и он не совпадает ни с сортировкой
   * языка страницы, ни с английской. Замер на русской витрине: из 132
   * стран 125 стоят не на местах русской сортировки и 120 — не на местах
   * английской. Начало списка: «Албания, Алжир, Андорра, Ангилья».
   *
   * Воспроизвести этот порядок нечем, а вставка «примерно туда» хуже
   * явного решения: покупатель ищет свою страну и не находит. Первым
   * пунктом он виден сразу, на любом из 21 языка витрины.
   */
  /*
   * Страна есть среди рынков магазина, но продаёт её другой сайт.
   *
   * Так с Казахстаном: рынок KZ в Shopify остался, а wau.kz с 06.10.2026
   * работает на Битриксе. Родной пункт отправлял форму смены страны,
   * Shopify отвечал 307 на wau.kz/localization, а такого адреса на новом
   * сайте нет — покупатель видел «Страница не найдена» (проверено 08.10).
   *
   * Пункт оставляем на месте — там его и ищут — и делаем ссылкой на
   * главную. Отправку формы тема вешает обработчиком на сам элемент,
   * снаружи его не снять, поэтому элемент заменяется копией: cloneNode
   * обработчиков не переносит, а без data-disclosure-option тема их
   * заново не навесит, даже если перепривяжет пункты.
   *
   * Порядок с темой безопасен в обе стороны. Тема привязывает пункты
   * в том же вызове, где вставляет список; наблюдатель срабатывает
   * позже и меняет уже привязанный элемент. Если же скрипт успел раньше
   * темы, у копии нет атрибута, и тема её пропускает.
   */
  function redirectNative(link, target) {
    var copy = link.cloneNode(true);
    copy.removeAttribute('data-disclosure-option');
    copy.href = target.url;
    copy.hreflang = target.hreflang;
    copy.rel = 'noopener';
    link.replaceWith(copy);
    copy.closest('li').setAttribute(MARK, target.code);
  }

  function fill(list) {
    // Пока пунктов нет, список ещё не подгружен — ждём.
    if (!list.querySelector('.disclosure-list__item')) return false;

    TARGETS.forEach(function (target) {
      if (list.querySelector('[' + MARK + '="' + target.code + '"]')) return;

      var native = list.querySelector('a[data-value="' + target.code + '"]');
      if (native) {
        redirectNative(native, target);
        return;
      }

      // Страны среди рынков нет — добавляем пункт сами. Так с Россией;
      // так же станет с Казахстаном, если рынок KZ уберут из магазина.
      list.insertBefore(buildItem(target, countryName(target.code)), list.firstChild);
    });

    return true;
  }

  function watch(form) {
    var list = form.querySelector('.disclosure-list');
    if (!list || list.hasAttribute('data-external-store-watched')) return;
    list.setAttribute('data-external-store-watched', 'true');

    if (fill(list)) return;

    var observer = new MutationObserver(function () {
      if (fill(list)) observer.disconnect();
    });
    observer.observe(list, { childList: true });
  }

  function boot(root) {
    (root || document).querySelectorAll('localization-form').forEach(function (form) {
      if (form.querySelector('input[name="country_code"]')) watch(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Пересборка секции в редакторе темы.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  /* ------------------------------------------------------------------
   * Предложение перейти в магазин своей страны
   *
   * Показывается посетителю, которого Shopify определил в России.
   * Казахстанца не спрашиваем, а уводим — см. leave(); всё сказанное
   * ниже про ошибки определения поэтому и делает переброс однократным.
   *
   * Три решения, принятых намеренно:
   *
   * 1. Предложение, а не переадресация. Определение по адресу ошибается:
   *    VPN, командировка, оператор связи. Увести человека с сайта против
   *    его воли — потерять покупателя, а не помочь ему.
   *
   * 2. Ответ запоминается навсегда. Показать один раз и замолчать: окно,
   *    всплывающее на каждой странице, раздражает сильнее, чем помогает.
   *
   * 3. Молчим, если страна не определилась. Ошибка в эту сторону
   *    безвредна — человек просто не увидит подсказки. Ошибка в другую
   *    сторону выгоняет покупателя из магазина, где он собирался
   *    покупать.
   *
   * Страну отдаёт сам Shopify: /browsing_context_suggestions.json,
   * поле detected_values.country.handle. Это тот же источник, которым
   * пользуется его собственная подсказка о стране.
   *
   * Проверить окно без российского адреса:
   *
   *   ?geo_test=RU                   показать, ответ не запоминать
   *   ?geo_test=RU&geo_remember=1    как у настоящего посетителя:
   *                                  ответ запоминается, и окно больше
   *                                  не появляется
   *   ?geo_test=reset                забыть ответ
   *
   * Второй режим нужен, чтобы проверялось и «показать один раз». Без
   * него это осталось бы непроверенным: настоящий российский адрес
   * нашими средствами не подделать.
   * ------------------------------------------------------------------ */

  var ANSWER_KEY = 'wau:external-store-offer';
  var REDIRECT_KEY = 'wau:external-store-redirect';

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function answered() {
    try {
      return localStorage.getItem(ANSWER_KEY) !== null;
    } catch (e) {
      // Приватный режим может запрещать хранилище. Тогда лучше
      // не показывать вовсе, чем показывать на каждой странице.
      return true;
    }
  }

  function remember(answer) {
    try {
      localStorage.setItem(ANSWER_KEY, answer);
    } catch (e) {}
  }

  function forget() {
    try {
      localStorage.removeItem(ANSWER_KEY);
    } catch (e) {}
  }

  function targetFor(code) {
    for (var i = 0; i < TARGETS.length; i++) {
      if (TARGETS[i].code === code && (TARGETS[i].offer || TARGETS[i].redirect)) return TARGETS[i];
    }
    return null;
  }

  /*
   * Переброс — только для стран с redirect: true (Казахстан).
   *
   * Владелец решил уводить, а не предлагать: доставки в Казахстан отсюда
   * нет. Довод против переброса из шапки раздела — определение по адресу
   * ошибается — остаётся в силе, поэтому переброс однократный:
   *
   *   - уводим один раз на браузер и запоминаем это. Вернулся на
   *     wauglobal.com сам — значит, ему сюда, второй раз не уводим;
   *   - нечем запомнить (хранилище запрещено) — не уводим вовсе: иначе
   *     человек с казахстанским VPN не попал бы на сайт никогда;
   *   - location.replace, а не присваивание адреса: «назад» в браузере
   *     ведёт туда, откуда пришёл, а не обратно под переброс.
   *
   * Проверить без казахстанского адреса: ?geo_test=KZ уводит, ничего
   * не запоминая; ?geo_test=reset забывает и переброс.
   */
  function redirectedBefore() {
    try {
      return localStorage.getItem(REDIRECT_KEY) !== null;
    } catch (e) {
      return true;
    }
  }

  function leave(target, remembering) {
    if (remembering) {
      try {
        localStorage.setItem(REDIRECT_KEY, target.code);
        if (localStorage.getItem(REDIRECT_KEY) !== target.code) return;
      } catch (e) {
        return;
      }
    }
    window.location.replace(target.url);
  }

  function detectCountry() {
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country;
        return (c && c.handle) || null;
      })
      .catch(function () { return null; });
  }

  var STYLES =
    '.external-store-offer{position:fixed;z-index:1000;inset-inline:1.6rem;bottom:1.6rem;' +
    'margin-inline:auto;max-width:42rem;padding:2rem;display:grid;gap:1.2rem;' +
    'background:#fff;background:rgb(var(--color-background));' +
    'color:#111;color:rgb(var(--color-foreground));' +
    'border:1px solid rgba(0,0,0,.12);border-color:rgb(var(--color-border));' +
    'border-radius:var(--card-corner-radius,8px);box-shadow:0 6px 24px rgba(0,0,0,.14)}' +
    // Заголовку нужен отступ справа: иначе он уходит под крестик.
    '.external-store-offer__title{margin:0;font-weight:600;padding-inline-end:3.6rem}' +
    '.external-store-offer__text{margin:0}' +
    '.external-store-offer__actions{display:flex;flex-wrap:wrap;gap:1rem;align-items:center}' +
    '.external-store-offer__go{text-align:center}' +
    // padding:0 обязателен. У кнопок темы padding: 0 40px, а при
    // box-sizing: border-box отступ побеждает заданную ширину: крестик
    // выходил 80x32 вместо 32x32 и налезал на заголовок.
    '.external-store-offer__close{position:absolute;inset-inline-end:.8rem;top:.8rem;' +
    'width:3.2rem;height:3.2rem;padding:0;line-height:1;background:none;border:0;color:inherit;' +
    'font-size:2rem;cursor:pointer;display:flex;align-items:center;justify-content:center}';

  function injectStyles() {
    if (document.getElementById('external-store-offer-styles')) return;
    var style = document.createElement('style');
    style.id = 'external-store-offer-styles';
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  function showOffer(target, remembering) {
    if (document.querySelector('.external-store-offer')) return;
    injectStyles();

    var t = target.offer;
    var box = document.createElement('aside');
    box.className = 'external-store-offer';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', t.title);
    box.lang = 'ru';

    var title = document.createElement('p');
    title.className = 'external-store-offer__title';
    title.textContent = t.title;

    var text = document.createElement('p');
    text.className = 'external-store-offer__text';
    text.textContent = t.text;

    var actions = document.createElement('div');
    actions.className = 'external-store-offer__actions';

    var go = document.createElement('a');
    go.className = 'btn btn--primary external-store-offer__go';
    go.href = target.url;
    go.rel = 'noopener';
    go.textContent = t.go;
    go.addEventListener('click', function () {
      if (remembering) remember('go');
    });

    var stay = document.createElement('button');
    stay.type = 'button';
    stay.className = 'btn btn--plain';
    stay.textContent = t.stay;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'external-store-offer__close';
    close.setAttribute('aria-label', t.close);
    close.textContent = '×';

    function dismiss() {
      if (remembering) remember('stay');
      box.remove();
    }

    stay.addEventListener('click', dismiss);
    close.addEventListener('click', dismiss);

    actions.appendChild(go);
    actions.appendChild(stay);
    box.appendChild(close);
    box.appendChild(title);
    box.appendChild(text);
    box.appendChild(actions);
    document.body.appendChild(box);
  }

  function offer() {
    // В редакторе темы не показываем: секции там пересобираются, и окно
    // мешало бы контент-менеджеру. Посмотреть его можно на витрине
    // с ?geo_test=RU.
    if (window.Shopify && window.Shopify.designMode) return;

    var forced = param('geo_test');

    if (forced === 'reset') {
      forget();
      try {
        localStorage.removeItem(REDIRECT_KEY);
      } catch (e) {}
      return;
    }

    // Подставленная страна по умолчанию ответа не запоминает: иначе одна
    // проверка закрыла бы окно навсегда. С geo_remember=1 путь ровно тот
    // же, что у настоящего посетителя, — так проверяется «показать
    // один раз».
    var remembering = !forced || param('geo_remember') === '1';

    // На предложение уже ответил и переброс уже был — спрашивать страну незачем.
    if (!forced && answered() && redirectedBefore()) return;

    if (forced) {
      var target = targetFor(forced.toUpperCase());
      if (!target) return;
      if (target.redirect) {
        if (!remembering || !redirectedBefore()) leave(target, remembering);
      } else if (!remembering || !answered()) {
        showOffer(target, remembering);
      }
      return;
    }

    detectCountry().then(function (code) {
      if (!code) return;
      var detected = targetFor(code);
      if (!detected) return;
      if (detected.redirect) {
        if (!redirectedBefore()) leave(detected, true);
      } else if (!answered()) {
        showOffer(detected, true);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', offer);
  else offer();
})();
